import { createDefaultPageConfig } from '@/data/adminMockData'

const STORAGE_KEY = 'pharmaid_published_page_config'
export const PAGE_CONFIG_UPDATED = 'pharmaid-page-config-updated'

let cached = null
let cachedMeta = null

function readStorageRaw() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (parsed && parsed.config) return parsed
    return { config: parsed, publishedAt: null }
  } catch {
    return null
  }
}

function readStorage() {
  const stored = readStorageRaw()
  return stored?.config ?? null
}

/** 已发布的页面配置；无发布记录时返回 null，前台继续用硬编码兜底 */
export function getPublishedPageConfig() {
  if (cached) return cached
  cached = readStorage()
  return cached
}

export function getPublishedMeta() {
  if (cachedMeta) return cachedMeta
  const stored = readStorageRaw()
  cachedMeta = stored ? { publishedAt: stored.publishedAt } : null
  return cachedMeta
}

export function savePublishedPageConfig(config) {
  const payload = {
    config: JSON.parse(JSON.stringify(config)),
    publishedAt: new Date().toISOString(),
  }
  cached = payload.config
  cachedMeta = { publishedAt: payload.publishedAt }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
  window.dispatchEvent(new CustomEvent(PAGE_CONFIG_UPDATED))
}

export function clearPublishedPageConfig() {
  cached = null
  cachedMeta = null
  localStorage.removeItem(STORAGE_KEY)
  window.dispatchEvent(new CustomEvent(PAGE_CONFIG_UPDATED))
}

/** 管理后台编辑用：有发布版用发布版，否则用默认种子数据 */
export function loadEditablePageConfig() {
  const published = getPublishedPageConfig()
  if (published) return JSON.parse(JSON.stringify(published))
  return JSON.parse(JSON.stringify(createDefaultPageConfig()))
}

export function getEnabledMenus() {
  const config = getPublishedPageConfig()
  if (!config?.menus) return null
  return [...config.menus]
    .filter((m) => m.enabled)
    .sort((a, b) => a.sort - b.sort)
}

export function getPageSettings(labelGroup) {
  const config = getPublishedPageConfig()
  if (!config?.pageSettings) return null
  return config.pageSettings[Number(labelGroup)] || null
}

export function getPublishedColumns(labelGroup) {
  const config = getPublishedPageConfig()
  if (!config?.columns) return null
  const cols = config.columns[Number(labelGroup)]
  if (!cols) return null
  return [...cols]
    .filter((c) => c.visible)
    .sort((a, b) => a.sort - b.sort)
    .map((c) => ({
      key: c.key,
      label: c.label,
      visible: c.visible,
      maxWidth: c.maxWidth ?? undefined,
      type: c.cellType === 'list' ? 'list' : undefined,
      cellType: c.cellType || 'text',
      detailVisible: c.detailVisible !== false,
    }))
}

export function getPublishedFilters(labelGroup) {
  const config = getPublishedPageConfig()
  if (!config?.filters) return null
  const filters = config.filters[Number(labelGroup)]
  if (!filters) return null
  return [...filters]
    .filter((f) => f.enabled)
    .sort((a, b) => a.sort - b.sort)
}
